import React from "react";
import { useNavigate } from "react-router-dom";

import { IRedirectAfterLoginAction } from "@/models";

import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { config, setRedirectAfterLogin } from "@/store/slices/config";
import {
  fetchPatientDeliveryAddress,
  setDeliveryAddressOpenClosed,
  setPrescriptionSelectionModalOpenClosed,
} from "@/store/slices/patient/medicine";

export const useRedirectAfterLogin = () => {
  const { redirectAfterLogin } = useAppSelector(config);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleRedirectAfterLogin = () => {
    if (!redirectAfterLogin?.isRedirect) return;
    navigate(redirectAfterLogin.path, {
      ...(redirectAfterLogin?.navItem && {
        state: { navItem: redirectAfterLogin.navItem },
      }),
    });

    switch (redirectAfterLogin?.action) {
      case IRedirectAfterLoginAction.OPEN_ADDRESS_FORM:
        dispatch(setDeliveryAddressOpenClosed());
        break;

      case IRedirectAfterLoginAction.SELECT_AND_PROCEED:
        dispatch(fetchPatientDeliveryAddress());
        if (redirectAfterLogin?.isSmallScreen) {
          dispatch(setPrescriptionSelectionModalOpenClosed());
        }
        break;

      case IRedirectAfterLoginAction.APPOINTMENT_CREATION:
        dispatch(
          setRedirectAfterLogin({
            ...redirectAfterLogin,
            action: IRedirectAfterLoginAction.OPEN_APPOINTMENT_CHECKOUT,
          })
        );
        break;

      default:
        break;
    }
  };
  return handleRedirectAfterLogin;
};
